// QA check with HW

import {UserDetailsMinRes} from '../cp';
import {Type} from 'class-transformer';
import {LicenseType} from '../../../enums/license-type';
import {LicensePeriod} from '../../../enums/license-period';
import {DeviceDataRes} from './device-data.contracts';
import {FileUploadRes} from '@yasc/yasc-material-components';

export class LicenseDataMinRes {
    guid!: string;
    licenseId!: string;
    licenceValid!: boolean;
    licenseType!: LicenseType;
    licensePeriod!: LicensePeriod;
    productName!: string;
    productVersion!: string;
    productDescription!: string;
    licenceStart!: Date;
    licenceExpires!: Date;
    autoRenewEnabled!: boolean;

    userAllowed!: number;
    userLeft!: number;

    devicesAllowed!: number; // -
    devicesLeft!: number; // backend calculated -

    fallbackProductVersion!: string;
    terminationPeriod!: number;
    terminationDate!: Date;
    licenseCost!: number;
    licenseCostPerUserYear!: number; // backend calculated
}
export class LicenseDataResponse {
    guid!: string;
    licenseId!: string;
    licenceValid!: boolean;
    licenseType!: LicenseType;
    licensePeriod!: LicensePeriod;
    productName!: string;
    productVersion!: string;
    productDescription!: string;
    licenceStart!: Date;
    licenceExpires!: Date;
    autoRenewEnabled!: boolean;
    userAllowed!: number;
    @Type(() => UserDetailsMinRes)
    userAssigned: UserDetailsMinRes[] = []; //-
    userLeft!: number; // backend calculated
    devicesAllowed!: number; // -
    @Type(() => DeviceDataRes)
    devicesAssigned: DeviceDataRes[] = []; //-
    devicesLeft!: number; // backend calculated -
    licenseKey!: string; // -
    fallbackProductVersion!: string;
    terminationPeriod!: number;
    terminationDate!: Date;
    licenseCost!: number;
    licenseCostPerUserYear!: number; // backend calculated
    @Type(() => FileUploadRes)
    attachmentList: FileUploadRes[] = []; //-
}

export class LicenseDataUReq {
    licenseId?: string;
    licenceValid?: boolean;
    licenseType?: LicenseType;
    licensePeriod?: LicensePeriod;
    productName?: string;
    productVersion?: string;
    productDescription?: string;
    licenceStart?: Date;
    licenceExpires?: Date;
    autoRenewEnabled?: boolean;
    userAllowed?: number;
    userAssigned?: number[] = [];
    devicesAllowed?: number;
    devicesAssigned?: string[] = [];
    licenseKey?: string;
    fallbackProductVersion?: string;
    terminationPeriod?: number;
    terminationDate?: Date;
    licenseCost?: number;
    attachmentList?: string[] = [];

    constructor(value:Partial<LicenseDataUReq>) {
        Object.assign(this, value);
    }
}

export class LicenseDataRequest {
    licenseId?: string;
    licenceValid?: boolean;
    licenseType?: LicenseType;
    licensePeriod?: LicensePeriod;
    productName?: string;
    productVersion?: string;
    productDescription?: string;
    licenceStart?: Date;
    licenceExpires?: Date;
    autoRenewEnabled?: boolean;
    userAllowed?: number;
    devicesAllowed?: number;
    licenseKey?: string;
    fallbackProductVersion?: string;
    terminationPeriod?: number;
    terminationDate?: Date;
    licenseCost?: number;
    attachmentList?: string[] = [];

    constructor(value:Partial<LicenseDataRequest>) {
        Object.assign(this, value)
    }
}

export class LicenseDataCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
